import axios from 'axios'

class FileService {
  /**
   * Récupère la liste des fichiers (temporaires et définitifs), paginée
   * @param {number} page - Numéro de la page
   * @param {number} limit - Nombre de fichiers par page
   * @param {string} search - Filtre par nom
   * @param {string} category - Filtre par catégorie (default, questions, etc.)
   * @param {string} type - Filtre par type de fichier (audio, image, video)
   * @returns {Promise<Object>} Liste des fichiers (temporaires et définitifs), paginée
   */
  async paginate({
    page = 1,
    limit = 20,
    search = null,
    category = null,
    type = null,
  } = {}) {
    const queryParams = {
      page,
      limit,
    }

    if (search !== null) {
      queryParams.search = search.trim()
    }
    if (category !== null) {
      queryParams.category = category
    }
    if (type !== null) {
      queryParams.type = type
    }

    try {
      const response = await axios.get('/api/files', {
        params: queryParams,
        withCredentials: true,
      })
      return response.data
    } catch (error) {
      console.error('Erreur lors de la récupération des fichiers:', error)
      throw error
    }
  }
}

export default new FileService()
